import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './user-profile.component.html';
import moment from 'moment';
import { InfoModal } from '../info-modal/info-modal.component';
import angular from 'angular';
//import { Component, ViewChild, ElementRef } from '@angular/core';

export const UserProfileComponent = {
    templateUrl,
    controller: UserProfileController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        addlInputs: "<",
        maritalStatusOptions: "<",
        changeFormMapping: "<",
        close: "&",
        dismiss: "&"
    }
};

function UserProfileController(onboardingActionPolicy, utilityService, $state, $timeout, employeeService,
    stateProvinceService, $q, $rootScope, onboardingDocumentViewService, localeService, $uibModal,
    onboardingDocumentService, $scope) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked profile) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('6', vm.application) === 'View';
    vm.identity;
    vm.userProfileForm;
    vm.userProfile;
    vm.GenderOptions = [];
    vm.isReadOnly = false;
    vm.onShowFederalW4 = onShowFederalW4;
    vm.updateChangeMapping = updateChangeMapping;
    //vm.dateValidation = dateValidation;
    vm.employeeBankInfo;
    vm.onSubmit = onSubmit;
    vm.onClose = onClose;
    vm.onEditPhone = onEditPhone;
    vm.revealSSNChar = revealSSNChar;
    vm.revealFEINChar = revealFEINChar;
    vm.ssnIsValidated = ssnIsValidated;
    vm.feinIsValidated = feinIsValidated;
    vm.InvalidDateDOB = invalidDateDOB;
    vm.changeDOB = changeDOB;
    vm.RequiredDOB = requiredDOB;
    vm.InvalidDateHireDate = invalidDateHireDate;
    vm.isSSNMismatched = isSSNMismatched;
    vm.ssnBlur = ssnBlur;
    vm.feinBlur = feinBlur;
    vm.retrieveLocale = retrieveLocale;
    vm.onMIToggle = onMIToggle;
    vm.hasOnbTypeFlag = false;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.originalSSN;
    vm.requireDateOfBirth;
    vm.requireGender;
    vm.userGender;
    vm.reqReview = false;
    vm.canApproveForm = (rt) => canApproveForm(vm.application, rt);
    vm.uniqueSSN = true;
    vm.loading = false;
    vm.miToggle = true;
    vm.editable = true;
    vm.is900 = false;
    vm.initData = [];
    vm.editData = [];
    vm.onChangeStateProvince = onChangeStateProvince;
    vm.validateSSN = validateSSN;
    vm.validateFEIN = validateFEIN;
    vm.requestReview = requestReview;
    vm.onChangeGender = onChangeGender;
    vm.onChangeCountry = onChangeCountry;
    vm.address;
    vm.isReadOnly = true; //hiredate flag
    vm.stateProvinceLabel = 'State';
    vm.postalCodeLabel = 'Zip Code';
    vm.setDirty = setDirty;
    vm.onEdit = onEdit;
    vm.isCompany = false;
    vm.reqFormChange = false;
    //@Output

    vm.formMapping = { '5': 'Federal W4', '-2': 'W9', '2': 'State W4', '3': 'I9' };
    //        5: "Federal W4",
    //            - 2: "W9"
    //}

    vm.datePickerOptions = {
        max: new Date(),
        change: function () {
            vm.editForm['DateOfBirth'].$setTouched();
            vm.editForm['DateOfBirth'].$setDirty();
        }
    };
    vm.hireDateOptions = {
        max: new Date(),
        change: function () {
            vm.editForm.HireDate.$setTouched();
            console.log(this.value());
        }
    };
    //vm.onShowDirectDeposit = onShowDirectDeposit;
    vm.state = {
        view: 'UserProfile'
    };

    //function identify() {
    //    angular.forEach(vm.editForm.$$controls, function (field, fieldName) {
    //        // Check if the field is a control and if it's dirty
    //        let currentValue = field.$$controls != null ? field.$$controls[0]?.$viewValue : field?.$viewValue;
    //        if (field != null && vm.initData[field.$name] != null && currentValue != vm.initData[field.$name]) {
    //            vm.editData[field.$name] = currentValue;
    //        }

    //    });
    //    console.log(vm.editData);
    //    var finalentry = vm.changeFormMapping.filter((item) => {
    //        return vm.editData[item.FieldName];
    //    });
    //    return updateChangeMapping(finalentry);
    //}

    function updateChangeMapping(data) {
        // Terminated employees: skip UpdateEmp/form-status reset entirely
        if (vm.application.EmployeeStatus === 'Terminated') {
            return $q.resolve();
        }
        const update = onboardingDocumentService.updateFormChange(vm.application.ApplicationNumber, data, false, false).then((res) => {
            console.log(res);
        });
        return utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(update, "Updating failed"));
    }

    //updateFormMapping: (utilityService, onboardingDocumentService, application, data) => {
    //    'ngInject';
    //    const update = onboardingDocumentService.updateChangeFormMapping(application.ApplicationId, data).then((res) => {
    //        console.log(res);
    //    });
    //    return utilityService.showLoadingUntilResolved(
    //        utilityService.alertOnError(update, "Updating failed"));

    //}
    function setDirty(name) {
        if (vm.editForm[name]) {
            vm.editForm[name].$setDirty();
        } else {
            console.log('no field found' + name);
        }

    }

    //vm.$postLink = function () {
    //    setInitialLoadValues();
    //}

    vm.$onInit = function () {
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        // 1099: only the W9 (FormID -2) change-form mapping applies; drop W2 forms (5/2/3).
        if (vm.application && vm.application.Is1099 && Array.isArray(vm.changeFormMapping)) {
            vm.changeFormMapping = vm.changeFormMapping.filter((m) => m.FormID === -2);
        }
        console.log(vm.resolve);
        vm.reqReview = false;
        //vm.editForm.$setPristine();
        vm.requireDateOfBirth = true;
        vm.requireGender = true;
        vm.GenderOptions = this.genderOptions;
        vm.stateProvinces = this.provinces;
        vm.isSiteAdmin = this.employee.IsSiteAdmin;
        vm.employmentRecord = this.employeeProfile.IcdOffices[0];
        vm.userProfile = this.profile;
        if (vm.userProfile && vm.userProfile.HomePhone) {
            vm.userProfile.HomePhone.PhoneNumber = formatPhoneNumber(vm.userProfile.HomePhone.PhoneNumber);
        }
        vm.address = this.profile?.HomeAddress;
        vm.employeeBankInfo = this.employeeBankInfo;
        //vm.employeeBankInfo.FEIN = vm.employeeBankInfo.FEIN || "";
        //vm.employeeBankInfo.confirmFEIN = vm.employeeBankInfo.confirmFEIN || "";

        //vm.employeeBankInfo.SSN = vm.employeeBankInfo.SSN || "";
        //vm.employeeBankInfo.confirmSSN = vm.employeeBankInfo.confirmSSN || "";

        if (vm.employeeBankInfo != null && vm.employeeBankInfo.CurrentFEIN != null) {
            vm.employeeBankInfo.taxNumberDisplayed = "fein";
        } else {
            vm.employeeBankInfo.taxNumberDisplayed = "ssn";
        }
        if (vm.addlInputs.hasOwnProperty("OnboardingType")) {
            if (vm.addlInputs["OnboardingType"] === 'i' || vm.addlInputs["OnboardingType"] === 'e') {
                vm.employeeBankInfo.taxNumberDisplayed = 'ssn';
                vm.hasOnbTypeFlag = true;
                vm.isCompany = false
            } else if (vm.addlInputs["OnboardingType"] === 'c') {
                vm.employeeBankInfo.taxNumberDisplayed = 'fein';
                vm.hasOnbTypeFlag = true;
                vm.isCompany = true;
            }
        }

        if (vm.application) {
            vm.editable = !(vm.application && vm.application.UserProfile !== null && vm.application.UserProfile !== 'Pending' && vm.application.UserProfile !== 'Review');
        }

        if (vm.employmentRecord !== undefined) {
            const syncPeriodEnd = moment(vm.employmentRecord.TerminationDate == null ? vm.employmentRecord.HireDate : vm.employmentRecord.TerminationDate).add(3, "weeks");
            vm.isReadOnly = this.employee.Roles.includes("Owner") && this.employee.MeridianEmployeeID != null && moment().isBefore(syncPeriodEnd, "day");
        }

        if (vm.userProfile && vm.userProfile.CompensationProfile && vm.userProfile.CompensationProfile.Id === 5) {
            vm.is900 = true;
            vm.requireDateOfBirth = false;
            vm.requireGender = false;
        }
        //if (vm.userProfile.HomePhone == null && vm.application.ApplicationStatus == 'Created') {
        //    vm.userProfile.HomePhone = { Id: 2298403, IsNew: false, IsDeleted: false, PhoneNumber: vm., Extension: null };
        //}

        if (this.provinces) {

            vm.countries = vm.stateProvinces.reduce(function (countries, stateProvince) {
                const isNew = countries.filter(function (country) {
                    return Number(country.CountryID) === Number(stateProvince.CountryID);
                }).length === 0;
                if (isNew && stateProvince.Country) {
                    countries.push(stateProvince.Country);
                }
                return countries;
            }, []).sort(function (a, b) {
                return a.CountryName < b.CountryName ? -1 : 1;
            });

            if (vm.address && vm.address.StateProvinceID && vm.address.StreetLine1) {
                vm.address.StateProvinceID = Number(vm.address.StateProvinceID)
                vm.address.StateProvince = vm.stateProvinces.filter(function (stateProvince) {
                    return Number(stateProvince.StateProvinceID) === Number(vm.address.StateProvinceID);
                })[0];

                vm.address.Country = vm.countries.filter(function (country) {
                    return vm.address.StateProvince && Number(country.CountryID)
                        === Number(vm.address.StateProvince.CountryID);
                })[0];
                vm.address.CountryID = vm.address.Country ? Number(vm.address.Country.CountryID) : null;

            } else {
                vm.address.StateProvinceID = null;
                vm.address.StateProvince = null;
                vm.address.Country = null;
                vm.address.CountryID = 1;
                vm.address.Country = vm.countries.filter(function (country) {
                    return Number(country.CountryID) === Number(1);
                })[0];
            }

            updateFilteredStateProvinces(vm.address.Country);



            /* vm.address.StateProvinceID = (vm.address && vm.address.StateProvince && vm.address.StreetLine1) ? Number(vm.address.StateProvince.StateProvinceID) : null;*/



        }


        if (this.genderOptions) {
            vm.userProfile.Gender = vm.GenderOptions.filter(function (gender) {
                return gender.Value === vm.userProfile.GenderId;
            })[0];
            this.userGender = this.genderOptions.find(gender => gender.Value === this.userProfile.GenderId);
        }

        vm.retrieveLocale()
            .then(function (locale) {
                console.log(locale);
                let localeID = locale.localeID;
                if (vm.address != null && vm.address.CountryID != null) {
                    //override locale to user profile
                    localeID = vm.address.CountryID === 1 ? 'en_US' : 'en_CA';
                }
                vm.employeeBankInfo.LocaleID = localeID;
                vm.employeeBankInfo.ShowMaritalStatus = vm.employeeBankInfo.CountryID === 1;
                return vm.retrieveLocaleTranslations(localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;
                vm.stateProvinceLabel = translations.StateProvince;
                vm.postalCodeLabel = translations.PostalCode;
                //translations.FEINMask = "00-0000000";
                console.log(vm.employeeBankInfo);
                //vm.formControlsSnapShot = angular.copy(vm.editForm.$$controls)
            });
        //Set MI Toggle value on load
        if (vm.addlInputs.hasOwnProperty("MIToggle")) {
            vm.miToggle = vm.addlInputs["MIToggle"] === "true";
        } else {
            onMIToggle(vm.miToggle);
        }
        vm.editable = resolveEditable();
        if (vm.editable) {
            $timeout(setInitialLoadValues);  // form starts editable, capture now
        }
        utilityService.hideLoading();

    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.UserProfile;

        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        // Submitted or Approved UserProfile: locked so the Edit button shows
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') return true;

        return !formStatus                      // no HasUserProfile field � check null/empty
            || formStatus === 'Pending'
            || formStatus === 'Submitted'
            || formStatus === 'ReviewRequired';
    }

    function onChangeCountry() {
        if (vm.address.Country) {
            vm.address.CountryID = Number(vm.address.Country.CountryID);
        } else {
            vm.address.CountryID = null;
        }
        updateFilteredStateProvinces(vm.address.Country);
        vm.address.StateProvince = null;
        vm.address.StateProvinceID = null;
        loadLocaleTranslations(vm.locales, vm.address.Country);
        vm.setDirty('CountryID');
    }

    function onChangeStateProvince() {
        //vm.address.StateProvince = vm.stateProvinces.filter(function (stateProvince) {
        //    return Number(stateProvince.StateProvinceID) === Number(vm.address.StateProvinceID);
        //})[0];
        if (vm.address.StateProvince) {
            vm.address.StateProvinceID = Number(vm.address.StateProvince.StateProvinceID);
        } else {
            vm.address.StateProvinceID = null;
        }
        vm.setDirty('StateProvinceID')
        //vm.address.StateProvinceID = vm.address.StateProvince?.StateProvinceID ?? null;
    }

    function onEdit() {
        vm.editable = !vm.editable
        if (vm.initData.length === 0) {
            setInitialLoadValues();
        }
    }

    function setInitialLoadValues() {

        angular.forEach(vm.editForm.$$controls, function (field, fieldName) {
            // Check if the field is a control and if it's dirty
            if (field && field.$name !== '' && field.$name !== null && !vm.initData.some(item => item.hasOwnProperty(field.$name))) {
                vm.initData[field.$name] = (field.$$controls === null || field.$$controls === undefined) ? field?.$viewValue : field.$$controls[0]?.$viewValue;
            }
        });
    }

    $scope.$watch('vm.userProfile.DateOfBirth', function (newVal, oldVal) {
        changeDOB();
    });
    //function dateValidation() {
    //    vm.editForm.DateOfBirth.$setTouched();
    //}
    function onMIToggle(toggle) {
        return onSaveAddlInputs(vm.employee.EmployeeID, "MIToggle", toggle);
    }

    function onSaveAddlInputs(employeeId, fieldName, value) {
        return onboardingDocumentService.setAddlInput(employeeId, fieldName, value);
    }

    function requestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '6');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Request review failed")
        );
    }

    //function requestReview() {
    //    utilityService.showLoading();
    //    let save = onboardingDocumentService.saveComment({
    //        ApplicationId: vm.application.ApplicationId,
    //        UserName: vm.owner.UserName,
    //        Text: vm.commentText,
    //    });
    //    let statusChange = onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '6');

    //    const trans = $q.all(save).then((res) => {
    //        if (res) {
    //            statusChange();
    //        }
    //    }).then(() => {
    //        vm.close({ $value: 'ok' });
    //    }).catch((err) => {
    //        return $q.reject(err);
    //    });

    //    utilityService.showLoadingUntilResolved(
    //        utilityService.alertOnError(trans, "Approve failed")
    //    );
    //    //$q.all([save, statusChange])
    //    //    .then((res) => {
    //    //        if (res[0] && res[1]) {
    //    //            vm.reqReview = false;
    //    //        }
    //    //        vm.close({ $value: 'ok' });
    //    //    }).catch((err) => {
    //    //        console.log(err);
    //    //        utilityService.hideLoading();
    //    //    });

    //}

    function onShowFederalW4() {
        //return $state.go('onboarding-document.federalW4');
        /*return $state.go('application-status');*/
        vm.close({ $value: 'ok' });
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.editForm.$dirty && !vm.isSaved) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function onEditPhone() {
        $uibModal.open({
            ...InfoModal,
            resolve: {
                notification: () => "If changes are required reach out to apexsupport@herbjoyent.com",
                showCancel: () => false,
                continue: () => "Okay"
            }
        });
    }

    function formatPhoneNumber(phone) {
        const digits = (phone || "").replace(/[^0-9]/g, "");
        const base = digits.substring(0, 10);
        let formatted;
        if (base.length > 6) {
            formatted = base.substring(0, 3) + "-" + base.substring(3, 6) + "-" + base.substring(6);
        } else if (base.length > 3) {
            formatted = base.substring(0, 3) + "-" + base.substring(3);
        } else {
            formatted = base;
        }
        return formatted;
    }

    //function onShowFederalW4Owner() {
    //    /*$rootScope.$broadcast('childStateChanged', { newState: 'application-status.ownermodal.federalW4', title: 'Employer View: Federal W4' });*/
    //    return $state.go('application-status.ownermodal.federalW4');
    //}

    function onChangeGender() {
        vm.userProfile.GenderId = (vm.userGender != null) ?
            vm.userGender.Value : null
        // Check if the input has a value and remove the class accordingly
        if (vm.userProfile.GenderId != null) {
            $('#Gender').removeClass('invalid-input');
        }
        vm.setDirty('GenderID');

    }

    function onApprove() {
        let approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "6");
        const trans = $q.all(approvePromise).then((res) => {
            if (res) {
                onShowFederalW4();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }

    // APEX-977: any profile change re-opens ALL currently-required signable forms for re-signing
    // (Is1099 -> W9; otherwise Federal W4 / State W4 / I9, whichever the app requires). Replaces the
    // former per-field diff so a dirty profile deterministically re-signs the affected forms.
    function resignFormIds() {
        if (vm.application.Is1099) {
            return vm.application.HasFW4Form ? [-2] : [];
        }
        var ids = [];
        if (vm.application.HasFW4Form) ids.push(5);
        if (vm.application.HasSW4Form) ids.push(2);
        if (vm.application.HasI9Form) ids.push(3);
        return ids;
    }

    function onSubmit() {
        //utilityService.showLoading();
        vm.editData = []; //clear each instance
        vm.reqFormChange = vm.application.HasFW4Form || vm.application.HasSW4Form || vm.application.HasI9Form;
        if (vm.ownerView) {
            return onApprove();
        } else {
            if (vm.editForm && vm.editForm.$invalid) {
                alert("Form is invalid. Fill the required fields.");
                return false;
            }
            if (!vm.uniqueSSN) {
                alert("SSN is not unique.");
            }
            if (vm.employeeBankInfo.FEIN) {
                if (vm.employeeBankInfo.FEIN !== vm.employeeBankInfo.confirmFEIN) {
                    alert("Please confirm FEIN");
                    return;
                }
            }
            console.log(vm.userProfile.Id);

            //if (vm.application.ApplicationStatus === 'Approved' && vm.application.UserProfile === 'Approved' && !vm.ownerView) {
            if (!vm.ownerView && vm.reqFormChange && vm.editForm && vm.editForm.$dirty) {
                var resignIds = resignFormIds();
                if (resignIds.length) {
                    var names = resignIds.map(function (id) {
                        return vm.formMapping[String(id)];
                    });
                    var res = confirm("For your changes to be finalized, the following forms will have to be resigned:" + names);
                    if (!res) {
                        return;
                    }
                }
            }

            //set change detection for form resign

            //let formPromises = [];
            let updatePromises = [];
            let startApplicationPromise = $q.resolve();
            if (vm.application.ApplicationStatus === 'Created' || !vm.application.UserProfile || vm.application.UserProfile === 'Pending' || vm.application.UserProfile === 'ReviewRequired') {
                //if (vm.application.UserProfile === 'Pending' && vm.application.EmployeeStatus === 'Active') {
                //    // Employee is active with pending user profile - add empty promise to prevent early exit to onShowFederalW4
                //    updatePromises.push($q.resolve());
                //} else {
                // Start Application into Onboarding.Application
                startApplicationPromise = onboardingDocumentService.startApplication(vm.employee.EmployeeID);
                updatePromises.push(startApplicationPromise);
                //}
            }
            if (vm.editForm && vm.editForm.$dirty) {
                vm.address.StateName = vm.address.StateProvince.StateName;
                vm.address.StateProvinceID = vm.address.StateProvince.StateProvinceID;
                vm.userProfile.HomeAddress = vm.address;
                //added for bug apex395
                updatePromises.push(employeeService.updateEmployeeProfile(vm.userProfile.Id, vm.userProfile, true));
                updatePromises.push(onboardingDocumentService.updateBankInfo(vm.userProfile.Id, vm.employeeBankInfo));
                updatePromises.push(onMIToggle(vm.miToggle));

                //using a mix of input dirty check and manual check to find out if hiredate is changed
                //if (vm.editForm.HireDate.$dirty) {
                //    vm.employeeProfile.IcdOffices[0] = vm.employmentRecord;
                //    updatePromises.push(employeeService.updateOnboardingEmployee(vm.userProfile.Id, vm.employeeProfile));
                //}

                //const update = $q.all([startApplicationPromise, ...updatePromises]);

                //    .then(([addAppResult, profileUpdateResult, bankUpdateResult]) => {
                //    if (addAppResult !== undefined) {
                //        // Handle addApplication result
                //    }
                //    if (vm.editForm && vm.editForm.$dirty) {
                //        console.log(profileUpdateResult);
                //        console.log(bankUpdateResult);
                //    }
                //});
            }

            if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
                return onShowFederalW4();
            }

            const trans = $q.all(updatePromises).then((data) => {
                //if (vm.application.ApplicationStatus === 'Approved' && vm.application.UserProfile === 'Approved' && !vm.ownerView && data) {
                if (vm.reqFormChange && !vm.ownerView && data) {
                    // APEX-977: resign the applicable forms deterministically (no per-field diff).
                    var finalData = resignFormIds().map(function (id) {
                        return { FormID: id };
                    });
                    return (vm.application.EmployeeStatus === 'Terminated' || !finalData.length)
                        ? $q.resolve(200)
                        : onboardingDocumentService.updateFormChange(vm.application.ApplicationNumber, finalData, false, false);
                } else {
                    return $q.resolve(200);
                }
            }).then((res) => {
                if (res) {
                    onShowFederalW4();
                }
            }).catch((err) => {
                return $q.reject(err);
            });

            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(trans, "Save failed")
            );
        }
        //    const retrieveIdentity = employeeService.retrieveIdentity();
        //    const loadInitialData = retrieveIdentity
        //        .then((employee) => {
        //            let updatePromises = [];

        //            if (vm.editForm && vm.editForm.$dirty) {
        //                updatePromises.push(employeeService.updateEmployeeProfile(vm.userProfile.Id, vm.userProfile));
        //                updatePromises.push(onboardingDocumentService.updateBankInfo(vm.userProfile.Id, vm.employeeBankInfo));
        //            }

        //            let addApplicationPromise = Promise.resolve(); // Create a resolved promise by default

        //            if (!vm.isExists) {
        //                // Add Application into Onboarding.Application, if not exists
        //                addApplicationPromise = onboardingDocumentService.addApplication(employee.EmployeeID);
        //            }

        //            return $q.all([addApplicationPromise, ...updatePromises]);
        //        }).then(([addAppResult, profileUpdateResult, bankUpdateResult]) => {
        //            if (addAppResult !== undefined) {
        //                // Handle addApplication result
        //            }
        //            if (vm.editForm && vm.editForm.$dirty) {
        //                console.log(profileUpdateResult);
        //                console.log(bankUpdateResult);
        //            }
        //            //return vm.state.go("employee.edit.bankInfo");

        //        });
        //    formPromises.push(loadInitialData);
        //}

        //onboardingDocumentService.resolvePromise(formPromises, vm.onShowFederalW4());
    }

    //function ResolvePromise(formPromises, returnPromise) {
    //    utilityService.showLoadingUntilResolved(
    //        utilityService.alertOnError($q.all([formPromises]), "Initial load failed"))
    //        .then(() => {
    //            utilityService.hideLoading();
    //            return $q.when(returnPromise);//vm.onShowFederalW4();
    //        }).catch((err) => {
    //            utilityService.hideLoading();
    //            alert("Retrieving failed: " + utilityService.getExceptionMessage(err));
    //        });
    //}

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                translations.FEINMask = "00-0000000";
                return translations;
            });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                vm.locales = locales;
                console.log(vm.employeeBankInfo.CountryID);
                return locales.filter(function (locale) {
                    console.log(vm.employeeBankInfo.CountryID);
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function updateFilteredStateProvinces(country) {
        vm.filteredStateProvinces = vm.stateProvinces.filter(function (stateProvince) {
            // Only show states belonging to the selected country if a country is selected.
            return !country || stateProvince.CountryID === country.CountryID;
        });

    }

    //function ssnIsValidated() {
    //    if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
    //        if ((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) {
    //            return false;
    //        }
    //    }
    //    return true;
    //}
    function ssnIsValidated() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
            if (((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) && vm.employeeBankInfo.confirmSSN === "") {
                return true;
            }
        }

        return false;
    }

    function feinIsValidated() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.feinChanged) {
            if (((vm.employeeBankInfo.FEIN || "") !== (vm.employeeBankInfo.confirmFEIN || "")) && vm.employeeBankInfo.confirmFEIN === "") {
                return false;
            }
        }
        return true;
    }

    function isValidDate(dateString) {
        // Check if the date string matches the MM/dd/yyyy format using a regular expression
        var dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
        if (!dateRegex.test(dateString)) {
            return false; // Return false if the date format is invalid
        }
        // Return true if the date is valid
        return true;
    }

    function changeDOB() {
        var dateOfBirth = vm.userProfile.DateOfBirth;
        var today = new Date();
        if (dateOfBirth == null) {
            vm.editForm.DateOfBirth.$setValidity('range', true);
            vm.editForm.DateOfBirth.$setValidity('required', false);
        } else if (dateOfBirth > today) {
            vm.editForm.DateOfBirth.$setValidity('required', true);
            vm.editForm.DateOfBirth.$setValidity('range', false);
        } else {
            vm.editForm.DateOfBirth.$setValidity('range', true);
            vm.editForm.DateOfBirth.$setValidity('required', true);
        }
    }

    function invalidDateDOB() {
        var dateOfBirth = vm.userProfile.DateOfBirth;

        if (dateOfBirth == null) {
            return false;
        }
        // Extract month, day, and year from dateOfBirth
        var month = dateOfBirth.getMonth() + 1; // Months are zero-based, so add 1
        var day = dateOfBirth.getDate();
        var year = dateOfBirth.getFullYear();

        // Format month, day, and year to MM/dd/yyyy format
        var dateString = ('0' + month).slice(-2) + '/' + ('0' + day).slice(-2) + '/' + year;


        return isValidDate(dateString);
    }

    function requiredDOB() {
        var dateOfBirth = vm.userProfile.DateOfBirth;

        if (dateOfBirth == null) {
            return true;
        }
        // Extract month, day, and year from dateOfBirth


        return false;
    }


    function invalidDateHireDate() {
        var dateOfBirth = vm.employmentRecord.HireDate;

        if (dateOfBirth == null) {
            return false;
        }
        // Extract month, day, and year from dateOfBirth
        var month = dateOfBirth.getMonth() + 1; // Months are zero-based, so add 1
        var day = dateOfBirth.getDate();
        var year = dateOfBirth.getFullYear();

        // Format month, day, and year to MM/dd/yyyy format
        var dateString = ('0' + month).slice(-2) + '/' + ('0' + day).slice(-2) + '/' + year;


        return !isValidDate(dateString);
    }


    //// Function to check if SSN is required
    //function isSSNRequired() {
    //    return vm.editForm.confirmSSN.$error.required && (vm.editForm.confirmSSN.$touched || vm.editForm.$submitted);
    //}

    // Function to check if SSN and Confirm SSN do not match
    function isSSNMismatched() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
            if ((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) {
                return true;
            }
        }
        return false;
    }


    function ssnBlur() {
        //vm.editForm.ConfirmSSN.$setValidity('ssnMismatch', true);
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.SSN !== vm.employeeBankInfo.originalSSN) {
            vm.employeeBankInfo.ssnChanged = true;
        } else {
            vm.employeeBankInfo.ssnChanged = false;
        }

        if (vm.employeeBankInfo.SSN !== "" && vm.employeeBankInfo.SSN !== undefined) {
            vm.loading = true;
            vm.editForm.SSN.$setValidity('unique', true);
            return employeeService.hasUniqueSSN(vm.employee.EmployeeID, vm.employeeBankInfo.SSN).then((data) => {
                vm.uniqueSSN = data;
                vm.uniqueSSN = vm.uniqueSSN && vm.employeeBankInfo.ssnChanged;
                vm.editForm.SSN.$setValidity('unique', vm.uniqueSSN);
                vm.loading = false;
            });
        }


    }

    function feinBlur() {
        //vm.editForm.ConfirmFEIN.$setValidity('feinMismatch', true);
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.FEIN !== vm.employeeBankInfo.originalFEIN) {
            vm.employeeBankInfo.feinChanged = true;
        } else {
            vm.employeeBankInfo.feinChanged = false;
        }

        if (vm.employeeBankInfo.FEIN !== "" && vm.employeeBankInfo.FEIN !== undefined) {
            vm.loading = true;
            vm.editForm.FEIN.$setValidity('unique', true);
            return employeeService.hasUniqueSSN(vm.employee.EmployeeID, vm.employeeBankInfo.FEIN).then((data) => {
                vm.uniqueSSN = data;
                vm.uniqueSSN = vm.uniqueSSN && vm.employeeBankInfo.feinChanged;
                vm.editForm.FEIN.$setValidity('unique', vm.uniqueSSN);
                vm.loading = false;
            });
        }

        //if (vm.employeeBankInfo.FEIN !== vm.employeeBankInfo.originalFEIN) {
        //    vm.employeeBankInfo.feinChanged = true;
        //} else {
        //    vm.employeeBankInfo.feinChanged = false;
        //}
    }

    function validateSSN() {
        if (vm.employeeBankInfo != null) {
            if (vm.employeeBankInfo.SSN === null || vm.employeeBankInfo.SSN === "" || vm.employeeBankInfo.SSN === undefined) {
                vm.editForm.SSN.$setValidity('required', false);
            } else {
                vm.editForm.SSN.$setValidity('required', true);
            }

            if (vm.employeeBankInfo.confirmSSN === null || vm.employeeBankInfo.confirmSSN === "" || vm.employeeBankInfo.confirmSSN === undefined) {
                vm.editForm.ConfirmSSN.$setValidity('required', false);
            } else {
                vm.editForm.ConfirmSSN.$setValidity('required', true);
            }

            if (((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) && vm.employeeBankInfo.confirmSSN !== "" && vm.employeeBankInfo.SSN !== "") {
                vm.editForm.ConfirmSSN.$setValidity('ssnMismatch', false);
            } else {
                vm.editForm.ConfirmSSN.$setValidity('ssnMismatch', true);
            }
        }
    }

    function validateFEIN() {
        if (vm.employeeBankInfo != null) {
            if (vm.employeeBankInfo.FEIN === null || vm.employeeBankInfo.FEIN === "" || vm.employeeBankInfo.FEIN === undefined) {
                vm.editForm.FEIN.$setValidity('required', false);
            } else {
                vm.editForm.FEIN.$setValidity('required', true);
            }

            if (vm.employeeBankInfo.confirmFEIN === null || vm.employeeBankInfo.confirmFEIN === "" || vm.employeeBankInfo.confirmFEIN === undefined) {
                vm.editForm.ConfirmFEIN.$setValidity('required', false);
            } else {
                vm.editForm.ConfirmFEIN.$setValidity('required', true);
            }

            if (((vm.employeeBankInfo.FEIN || "") !== (vm.employeeBankInfo.confirmFEIN || "")) && vm.employeeBankInfo.confirmFEIN !== "" && vm.employeeBankInfo.FEIN !== "") {
                vm.editForm.ConfirmFEIN.$setValidity('feinMismatch', false);
            } else {
                vm.editForm.ConfirmFEIN.$setValidity('feinMismatch', true);
            }
        }
        console.log(
            'unfinished:',
            vm.editForm.FEIN.$error.unfinished,
            'raw:',
            vm.editForm.FEIN.$$rawModelValue
        );
    }



    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
    function revealFEINChar(fein, char, i) {
        return i > 4;
    }




    //unblock when implementing canada
    function loadLocaleTranslations(locales, country) {
        const getCurrentLocale = country ? $q.when(locales.filter(function (locale) {
            return locale.countryID === country.CountryID;
        })[0]) : localeService.retrieveCurrentLocale();

        // TODO: cache results.
        getCurrentLocale
            .then(function (currentLocale) {
                return localeService.retrieveLocaleTranslations(currentLocale.localeID);
            })
            .then(function (translations) {
                // Change the label text to that of the selected country.
                vm.stateProvinceLabel = translations.StateProvince;
                vm.postalCodeLabel = translations.PostalCode;
            });

    }

}


export const UserProfileModal = {
    component: "apexUserProfileModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
